import React from 'react';
import { formatDate, FormatDateType } from '../../../../helpers/date';
import type { MagazineArticleDateProps } from './interfaces';
import styles from './MagazineArticleDate.module.scss';

const MagazineArticleDate = ({
  date,
  placeholderDate = '',
}: MagazineArticleDateProps) => {
  const formattedDate = React.useMemo(() => {
    const currentDate = date;

    if (!currentDate) {
      return null;
    }

    return formatDate(
      typeof currentDate === 'string' ? new Date(currentDate) : currentDate,
      FormatDateType.Article
    );
  }, [date]);

  return (
    <div className={styles.base}>
      <div className={styles.date}>{formattedDate || placeholderDate}</div>
    </div>
  );
};

export default MagazineArticleDate;
